<template>
  <section class="section section--elevated">
    <LazyBg :src="bgSrc" />
    <div class="section-dim" aria-hidden="true" />
    <div class="container">
      <h2 class="section-title">企业文化</h2>
      <p class="section-lead">以技术向善，筑就智能未来</p>
      <p class="about-culture-intro">
        海曦技术始终坚信，优秀的企业文化是企业持续成长的核心动力。立足国产化 AI 赛道，我们以“技术自主、客户为心、开放共赢”为内核，构建兼具硬核科技实力与温暖人文关怀的文化体系。
      </p>

      <div class="benefits-list">
        <article v-for="(c, i) in cultures" :key="c.title" class="benefit-card">
          <span class="benefit-watermark" aria-hidden="true">{{ i + 1 }}</span>
          <h3>{{ c.title }}</h3>
          <p class="culture-sub">{{ c.sub }}</p>
          <ul v-if="c.items?.length" class="culture-list">
            <li v-for="item in c.items" :key="item">{{ item }}</li>
          </ul>
          <p v-else>{{ c.desc }}</p>
        </article>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import LazyBg from '@/components/LazyBg.vue';
import bgSrc from '@/assets/about_bg_culture.png';

const cultures = [
  {
    title: '核心价值观',
    sub: '技术向善，自主可控',
    items: ['客户第一，价值共生', '创新驱动，务实笃行', '开放共赢，生态共建']
  },
  {
    title: '企业使命',
    sub: '以国产化 AI 技术赋能千行百业',
    desc: '用科技创造安全、高效、普惠的社会价值，让 AI 成为推动政务高效、医疗普惠、工业提质、青少年健康成长的核心力量。'
  },
  {
    title: '企业愿景',
    sub: '国内领先的场景化 AI 解决方案提供商',
    desc: '持续深耕垂直行业场景，强化全链条技术能力，成为政企数字化转型中最可信赖的 AI 伙伴，引领国产化 AI 产业高质量发展。'
  },
  {
    title: '人才理念',
    sub: '以奋斗者为本，让成长与价值同行',
    items: [
      '尊重人才：提供平等发展机会与广阔成长空间',
      '赋能成长：技术培训 + 项目实践 + 导师带教',
      '共享成果：股权激励、绩效激励等多元机制',
      '崇尚奋斗：勇于担当，共创美好未来'
    ]
  },
  {
    title: '文化氛围',
    sub: '扁平协作 · 创新激励 · 人文关怀',
    items: [
      '扁平化管理，鼓励跨部门协作与开放沟通',
      '设立技术创新奖、场景落地奖激发创造力',
      '关注员工身心健康与工作生活平衡',
      '积极参与公益项目，以技术回馈社会'
    ]
  },
  {
    title: '合作共赢',
    sub: '产学研协同，共建国产化 AI 生态',
    desc: '深化产学研合作与产业伙伴联盟，以开放姿态连接芯片、算法、场景与资本力量，共同推动国产化 AI 生态繁荣。'
  }
];
</script>

<style scoped lang="scss">
.section.section--elevated {
  border-top-color: rgba(255, 255, 255, 0.08);
  border-bottom-color: rgba(255, 255, 255, 0.08);
}

.section-dim {
  position: absolute;
  inset: 0;
  z-index: 1;
  background: linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.45));
  pointer-events: none;
}

.container {
  position: relative;
  z-index: 2;
}

.about-culture-intro {
  max-width: 760px;
  margin: 0 auto 8px;
  text-align: center;
  font-size: 15px;
  line-height: 1.7;
  color: #fff;
  opacity: 0.7;
}

.culture-sub {
  margin: 0 0 12px;
  font-size: 14px;
  color: var(--accent, #45c1cf);
  opacity: 1;
}

.culture-list {
  margin: 0;
  padding-left: 1.2em;
  list-style: disc;
  font-size: 14px;
  line-height: 1.7;
  color: #fff;
  opacity: 0.7;

  li + li {
    margin-top: 6px;
  }
}
</style>
